import { SignOptions } from '@/types'
import { Widget } from '@/models'

/** 日期章是否可设置 */
export default function isDateSignSettable(options: SignOptions, widget: Widget) {
  const { dateSignSetting } = options

  if (typeof dateSignSetting === 'function') return dateSignSetting(widget)

  if (typeof dateSignSetting === 'boolean') return dateSignSetting

  return true
}
